<script>
export default {
    props: {
        variant: {
            type: String,
            required: true,
            default: '',
        },
        hover_text: {
            type: String,
            required: true,
            default: '',
        },
        id: {
            type: String,
            required: true,
            default: '',
        },
        icon_class: {
            type: String,
            required: true,
            default: '',
        },
        size: {
            type: String,
            required: false,
            default: 'sm'
        },
        action: {
            type: Function,
            required: true,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    components: {},
    data() {
        return {
            hover: false
        }
    },
    computed: {
        sizeToPx() { 
            switch(this.size) {
                case 'xs': return '28px'; break;
                case 'sm': return '32px'; break;
                case 'md': return '36px'; break;
                case 'lg': return '40px'; break;
                case 'xl': return '48px'; break;
                case 'xxl': return '56px'; break;
            }
        },
        sizeToFontSize() { 
            switch(this.size) {
                case 'xs': return 'font-18'; break;
                case 'sm': return 'font-22'; break;
                case 'md': return 'font-26'; break;
                case 'lg': return 'font-30'; break;
                case 'xl': return 'font-38'; break;
                case 'xxl': return 'font-46'; break;
            }
        }
    },
    mounted() {
        
    },
    methods: {},
    watch: {},
}
</script>

<template>
    <div class="d-inline-block">
        <b-button 
            :id="id" 
            :size="size"
            :variant="variant || 'transparent-primary'" 
            :class="hover ? `text-${variant.replace('transparent-','')} bg-soft--${variant} font-weight-bold` : 'text-primary bg-soft-primary shadow-none'"
            class="rounded-circle p-0 text-center"
            :style="`min-width: ${sizeToPx}; min-height: ${sizeToPx}; margin-right: 1px; margin-left: 1px; padding: 1px`" 
            @mouseover="hover = true"
            @mouseleave="hover = false"
            @click.stop="action"
            :disabled="disabled"
            >
            <i :class="icon_class + ' ' + sizeToFontSize" ></i>
        </b-button>
        <b-tooltip :target="id" 
            triggers="hover" 
            :variant="variant" 
            placement="left"
            >
            {{hover_text}}
        </b-tooltip>
    </div>
</template>

<style lang="scss">

</style>